export const selectStyles = {
  components: {
    Select: {
      baseStyle: {
        field: {
          fontWeight: 400,
          borderRadius: "12px",
        },
      },
      // Override ALL sizes so Chakra's default "md" size borderRadius:"md" (6px) doesn't win
      sizes: {
        xs: {
          field: { fontSize: "xs", px: 2, h: 6, borderRadius: "12px", paddingInlineEnd: "6" },
          icon: { insetEnd: "1" },
        },
        sm: {
          field: { fontSize: "sm", px: 3, h: 8, borderRadius: "12px", paddingInlineEnd: "7" },
          icon: { insetEnd: "2" },
        },
        md: {
          field: { fontSize: "md", px: 4, h: 10, borderRadius: "12px", paddingInlineEnd: "8" },
          icon: { insetEnd: "2" },
        },
        lg: {
          field: { fontSize: "lg", px: 4, h: 12, borderRadius: "12px", paddingInlineEnd: "8" },
          icon: { insetEnd: "2" },
        },
      },
    },
  },
};
